var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Configuración Alerta" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c("v-flex", { attrs: { sm4: "", md4: "" } }, [
                            _c(
                              "div",
                              { staticStyle: { "text-align": "start" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.formFields.mail.label,
                                    "single-line": "",
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: _vm.formFields.mail.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFields.mail,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "formFields.mail.value"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-style": "italic",
                                      margin: "0 auto",
                                      "font-size": "12px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Puede ingresar varios correos separados por punto y coma\n                  (;)"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "v-flex",
                            { attrs: { sm4: "", md4: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: _vm.formFields.tipoAlerta.label,
                                  items: _vm.listaTiposAlerta,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  multiple: ""
                                },
                                on: { change: _vm.changeTiposAlertas },
                                model: {
                                  value: _vm.formFields.tipoAlerta.items,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tipoAlerta,
                                      "items",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tipoAlerta.items"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm4: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.flota.label,
                                  items: _vm.listaFlotas,
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.changeFlota($event)
                                  }
                                },
                                model: {
                                  value: _vm.formFields.flota.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.flota, "value", $$v)
                                  },
                                  expression: "formFields.flota.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm4: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.grupo.label,
                                  items: _vm.listaGrupos,
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                model: {
                                  value: _vm.formFields.grupo.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.grupo, "value", $$v)
                                  },
                                  expression: "formFields.grupo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.esEditar,
                                  expression: "esEditar"
                                }
                              ],
                              attrs: { sm4: "", md4: "" }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: _vm.formFields.estado.label,
                                  items: [
                                    { id: true, nombre: "Activo" },
                                    { id: false, nombre: "Inactivo" }
                                  ],
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                model: {
                                  value: _vm.formFields.estado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.estado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.estado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-flex", { attrs: { sm2: "", md2: "" } }, [
                            _c(
                              "div",
                              { staticClass: "text-sm-center" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { flat: "", icon: "", small: "" },
                                    on: {
                                      click: _vm.handleModalBtnGuardarEditar
                                    }
                                  },
                                  [
                                    _c("v-icon", { staticClass: "BtnIcon" }, [
                                      _vm._v("save")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }